import React from "react";
import "./accordian.css"; // Optional: Add CSS for styling

const Accordion = ({ title, children, isOpen, onToggle }) => {
  return (
    <div className="accordion">
      <div className="accordion-header" onClick={onToggle}>
        <span>{title}</span>
        <span
          className="accordion-icon"
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            backgroundColor: "var(--white-color)",
            color: "var(--primary-color)",
            border: "1px solid var(--primary-color)",
            fontWeight: "bold",
            fontSize: "14px",
          }}
        >
          {isOpen ? "-" : "+"}
        </span>
      </div>
      {isOpen && (
        <div
          className="accordion-body"
          style={{
            overflow: "hidden",
            transition: "height 0.3s ease-in-out",
            height: isOpen ? "auto" : "0",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordion;
